module.exports = {"title":"Enter guardian","email":"Email","firstname":"First name","lastname":"Last name","emailPlaceholder":"Email","firstnamePlaceholder":"First name","lastnamePlaceholder":"Last name","cancelButton":"Cancel","inviteButton":"Invite"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/add-guardian.json
// module id = vO+y
// module chunks = 1